import { SacolaDataContext } from '@/contexts/SacolaDataContext';
import { useContext } from 'react';

export const useSacola = () => {
  const context = useContext(SacolaDataContext);
  if (!context) {
    throw new Error('useSacola deve ser utilizado SacolaDataContext');
  }
  return context;
};
